<p class="subheading" data-cy="paymentDateTextSubHeading">Payment Date</p>
@if (hasPastDue) {
  <div>
    <div class="pad-top-20" data-cy="selectedPastDueText">
      <p
        data-cy="futurePaymentNotEligible"
        dsContent
        [contentPath]="'shared.futurePaymentNotEligible'"
      ></p>
      <hr class="line" />
      <p data-cy="willBePaidTodayText" dsContent [contentPath]="'shared.willBePaidToday'"></p>
      <p class="bold" data-cy="selectPaymentDate">{{ todayDate | dateFormat: 'MMMM D' }}</p>
      <hr class="line" />
      <p
        class="bold"
        data-cy="unAbleToEditDate"
        dsContent
        [contentPath]="'shared.whyCantIEditTheDate'"
      ></p>
      <span dsContent [contentPath]="'shared.pastDueBill'"></span>
    </div>
  </div>
} @else {
  <div class="pad-top-20" data-cy="selectPaymentDateSubHeading">
    <span dsContent [contentPath]="'shared.selectAPaymentDate'"></span>
    <ds-radio-group
      data-cy="paymentDateOptionsRadioButtons"
      class="radio-group-container"
      [control]="'paymentDate'"
      [unselectAll]="unselectAll"
      [selectedAnswer]="'0'"
      [parentFormGroup]="formGroup"
      [options]="paymentDateOptions"
      [disableRadioControl]="disableRadioSelection"
      (optionSelected)="optionsSelected($event, picker)"
    >
    </ds-radio-group>
    <p
      data-cy="selecNewPaymentDateSubHeading"
      dsContent
      [contentPath]="'shared.selectANewPaymentDate'"
    ></p>
    <mat-form-field appearance="outline" style="width: 100%">
      <input
        matInput
        [min]="matDatePickerOptions.minDate"
        [max]="matDatePickerOptions.maxDate"
        [matDatepicker]="picker"
        formControlName="paymentDatePicker"
        [disabled]="matDatePickerOptions.isDisabled"
        (dateChange)="optionsSelectedDatePicker($event)"
        readonly
      />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
    </mat-form-field>
  </div>
}
